module.exports = __webpack_public_path__ + "img/spezialisierungen_3000.5e5e2636.png";